/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _newArrowCheck from "@babel/runtime-corejs3/helpers/esm/newArrowCheck";

var _this = this,
    _context;

import { makeStyles } from '@material-ui/core';
var useStyles = makeStyles(_bindInstanceProperty(_context = function _context(theme) {
  _newArrowCheck(this, _this);

  return {
    root: {
      '& fieldset': {
        borderWidth: 2,
        transition: 'border-color 0.2s linear'
      }
    },
    valid: {
      '& fieldset': {
        borderColor: "".concat(theme.palette.success[theme.palette.type], "!important")
      }
    },
    invalid: {
      '& fieldset': {
        borderColor: "".concat(theme.palette.error[theme.palette.type], "!important")
      }
    },
    highlight: {
      '& fieldset': {
        animation: '$blink 0.3s linear none 3',
        borderColor: "".concat(theme.palette.info[theme.palette.type], "!important")
      }
    },
    warning: {
      '& fieldset': {
        animation: '$blink 0.3s linear none 3',
        borderColor: "".concat(theme.palette.warning[theme.palette.type], "!important")
      }
    },
    standBy: {
      '& input:focus + fieldset': {
        borderColor: "".concat(theme.palette.action.focus, "!important")
      }
    },
    '@keyframes blink': {
      '0%': {
        opacity: 1
      },
      '50%': {
        opacity: 0.5
      },
      '100%': {
        opacity: 1
      }
    }
  };
}).call(_context, this));
export { useStyles };